import type { ComputedDateRange } from 'venn-utils';
import { DEFAULT_MAX_RANGE } from 'venn-ui-kit';

export const DEFAULT_RANGE: ComputedDateRange = {
  range: {},
  maxRange: DEFAULT_MAX_RANGE,
  frequency: 'DAILY',
};
